export const ACTION_CONSTS = {
  TOGGLE_STATUS_WIDGET: 'TOGGLE_STATUS_WIDGET',
  ADD_UPLOAD_FOLDER: 'ADD_UPLOAD_FOLDER',
  REMOVE_UPLOAD_FOLDER: 'REMOVE_UPLOAD_FOLDER',
  SET_FOLDER_RETRY: 'SET_FOLDER_RETRY',
  SET_FOLDER_ERROR: 'SET_FOLDER_ERROR',
  SET_FOLDER_UPLOAD_COMPLETE: 'SET_FOLDER_UPLOAD_COMPLETE',
  SET_FOLDER_UPLOAD_ID: 'SET_FOLDER_UPLOAD_ID',
  RESET_STATUS_WIDGET: 'RESET_STATUS_WIDGET',
};

export const STATE_KEYS = {
  IS_WIDGET_OPEN: 'isWidgetOpen',
  UPLOAD_FOLDERS: 'uploadFolders',
  UPLOAD_IDS: 'uploadIds',
};
